import ApexCharts from "components/ApexCharts";
import { useTheme } from "@mui/material";

const chartStyle = {
  height: 350,
  width: "100%",
};

const ScopeChart = ({ data, title = "", obj_key }) => {
  const theme = useTheme();
  return (
    <div style={chartStyle}>
      <ApexCharts
        type={"line"}
        series={[
          {
            name: "Emissions",
            type: "column",
            data: data ? data.map((e) => e[obj_key]) : [],
          },
        ]}
        height={"100%"}
        options={{
          colors: [theme.palette.chart.bar],
          chart: {
            type: "line",
            width: "100%",
            toolbar: {
              show: false,
            },
          },

          legend: {
            position: "top",
            showForSingleSeries: true,
          },
          tooltip: {
            y: {
              formatter: (value, opts) => {
                return value.toFixed(2) + " t CO2e";
              },
            },
          },
          title: {
            text: title,
            align: "center",
            style: {
              fontSize: "16px",
              fontWeight: "normal",
              fontFamily: "subheader",
            },
          },
          labels: data ? data.map((e) => e.emission_year) : [],
        }}
      />
    </div>
  );
};

export default ScopeChart;
